import { getMarbleContent, UserMarble } from "@hoylu/client-common";
import React, { type CSSProperties } from "react";
import type { User } from "../state/user/user.reducer";
import { hexToRgba } from "../utils/hexToRgba";
import { useI18n } from "../utils/hooks/use.i18n";
import Styles from "./UserProfileMarble.module.css";

export type UserProfileMarbleProps = {
  profile: User;
  userColor: string;
  onClick?: () => void;
};

const UserProfileMarble: React.FC<UserProfileMarbleProps> = ({
  profile,
  userColor,
  onClick,
}) => {
  const t = useI18n();

  const accountMarbleStyles: CSSProperties = {
    backgroundColor: userColor,
    color: hexToRgba("#000", 0.5),
  };

  return (
    <UserMarble
      // TODO: For accessibility we should probably use more informative text... just about anything would be better than "User Marble", whatever this is supposed to mean. I recommend something like "View user profile & settings." or "View profile for {user}.", although since this component is used in more than place, we should probably pass this in as props to match the use case where it is being rendered.
      aria-label={t("USER_PROFILE_WIDGET.USER_MARBLE")}
      className={Styles.profileMarble}
      data-test-id="logout-button"
      email={profile.email}
      onClick={onClick}
      style={accountMarbleStyles}
      title={profile.email}
    >
      {getMarbleContent(profile.firstName, profile.lastName)}
    </UserMarble>
  );
};

export default UserProfileMarble;
